export const releaseOwnListener = (unsubscribe) => {
  if (typeof unsubscribe !== "function") return false;
  unsubscribe();
  return true;
};
